export const whichDevice = () => {
  const width = window.innerWidth;
  switch (true) {
    case width < 768:
      return "mobile";
    default:
      return "pc";
  }
};
